const zxcvbn = require('zxcvbn');

// Set to true to re-enable zxcvbn strength scoring and UI feedback
const ZXCVBN_ENABLED = false;

// filter keyword input delay
function delay(callback, ms) {
  let timer = 0;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}

function checkStrength(el) {
  const pwId = el.getAttribute('data-password-strength-input');
  const password = el.value;

  const errors = [];
  if (!/[a-z]/.test(password)) {
    errors.push('Must include a lowercase letter');
  }

  if (!/[A-Z]/.test(password)) {
    errors.push('Must include an uppercase letter');
  }

  if (!/[0-9]/.test(password)) {
    errors.push('Must include a number');
  }

  if (!/[^A-Za-z0-9]/.test(password)) {
    errors.push('Must include a special character');
  }

  if (password.length < 10) {
    errors.push('Must be at least 10 characters');
  }

  if (password.length > 160) {
    errors.push('Must be less than 160 characters');
  }

  // zxcvbn scoring — kept for re-enable via ZXCVBN_ENABLED
  let result = { score: 0, feedback: { warning: '', suggestions: [] } };
  let strengthPercent = 0;

  if (ZXCVBN_ENABLED) {
    result = zxcvbn(password);
    const strength = result.score / 4;
    strengthPercent = strength * 100;
  }

  if (errors.length) {
    result.score = 0;
  } else if (!ZXCVBN_ENABLED) {
    // Requirements met — pass form validation without zxcvbn
    result.score = 4;
  }

  const pwStrength = document.querySelector(
    '[data-password-strength="' + pwId + '"]'
  );

  const bar = pwStrength.querySelector('[data-password-strength-bar]');
  const barFill = pwStrength.querySelector('[data-password-strength-bar-fill]');

  if (ZXCVBN_ENABLED) {
    bar.style.display = '';
    bar.setAttribute('score', result.score);
    barFill.style.width = strengthPercent + '%';
  } else {
    bar.style.display = 'none';
  }

  let feedback = '';

  if (errors.length) {
    feedback = '<strong>' + errors.join('<br />') + '</strong>';
  } else if (ZXCVBN_ENABLED) {
    feedback = '<strong>';

    if (result.score === 4) {
      feedback += 'Password Strength: Excellent';
    } else if (result.score === 3) {
      feedback += 'Password Strength: Good';
    } else if (result.score === 2) {
      feedback += 'Password Strength: Almost';
    } else if (result.score === 1) {
      feedback += 'Password Strength: Weak';
    } else if (result.score === 0) {
      feedback += 'Password Strength: Terrible';
    }
    feedback += '</strong>';

    if (result.feedback.warning.length) {
      feedback += '<br />' + result.feedback.warning;
    }

    if (result.feedback.suggestions.length) {
      const sugs = result.feedback.suggestions;
      for (const key in sugs) {
        if (Object.prototype.hasOwnProperty.call(sugs, key)) {
          feedback += '<br />' + sugs[key];
        }
      }
    }
  }

  pwStrength.querySelector('[data-password-strength-feedback]').innerHTML =
    feedback;

  pwStrength.querySelector('[data-password-strength-score]').value =
    result.score;
  pwStrength
    .querySelector('[data-password-strength-score]')
    .setAttribute('data-touched', 'true');
}

document.querySelectorAll('[data-password-strength-input]').forEach((el) => {
  console.log(el);
  el.addEventListener('change', function (e) {
    checkStrength(el);
  });

  el.addEventListener(
    'keydown',
    delay(function (event) {
      checkStrength(el);
    }, 100)
  );
});
